/*
 * @Author: hippo
 * @Date: 2023-04-08 23:12:42
 * @LastEditors: hippo
 * @LastEditTime: 2023-06-15 09:34:10
 * @FilePath: /subang-console/src/components/GlobalSearch/QuickPreview/Order.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import React, { useState, useCallback } from 'react'
import { useMount } from 'react-use'
import { connect } from 'react-redux'
import OrderDetail from '@/containers/workspace/components/OrderDetail'
import MessageList from '@/containers/workspace/components/MessageBox/List'
import styles from './order.module.scss'

export default function(props) {
  if (!props.orderId) {
    return (
      <div>缺少OrderId</div>
    )
  }
  console.log('props.orderId',props.orderId)
  return (
    <div className={styles.container}>
      <OrderDetail
        orderId={props.orderId}
        forceSync={true}
        readOnly={true}
        className={styles.detail} />
      <MessageList
        orderId={props.orderId}
        readOnly={true}
        className={styles.message} />
    </div>
  )
}
